import { useCallback, useEffect, useState } from "react";

// Global refresh trigger for questionnaire forms
let globalRefreshTrigger = Date.now();

export function useRefreshTrigger() {
  const [refreshTrigger, setRefreshTrigger] = useState(globalRefreshTrigger);

  const triggerRefresh = useCallback(() => {
    globalRefreshTrigger = Date.now();
    setRefreshTrigger(globalRefreshTrigger);
  }, []);

  // Sync with global state on mount and when it changes
  useEffect(() => {
    setRefreshTrigger(globalRefreshTrigger);
  }, []);

  return { refreshTrigger, triggerRefresh };
}
